var $accordion = $('.accordion .accordion-top');

$accordion.click(function() {
    $(this).parent('.accordion').toggleClass('open');
});